import { useState } from "react";
import { useTasks } from "../hooks/useTasks";
import { useAuth } from "../contexts/AuthContext";
import Checkmark from "./Checkmark";
import TaskModal from "./TaskModal";
import { format } from "date-fns";

export default function DayColumn({ date, isToday = false }) {
  const { isDemoMode, user } = useAuth();
  const { tasks, addTask, removeTask, toggleTask } = useTasks(
    date,
    isDemoMode,
    user?.uid
  );
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <div
        onClick={() => setIsModalOpen(true)}
        className="md:flex-1 p-2 md:p-4 rounded-2xl md:rounded-3xl cursor-pointer transition-colors bg-[#303030] shadow-[6px_6px_2px_rgba(0,0,0,.8)] flex flex-col w-full overflow-hidden"
      >
        <h3
          className={`text-[10px] md:text-sm font-bold mb-1.5 md:mb-3 uppercase text-white text-center rounded-xl md:rounded-2xl py-0.5 md:py-1 flex-shrink-0 ${
            isToday ? "bg-[#737373]" : ""
          }`}
        >
          {/* Mobile: First 3 letters, Desktop: Full name */}
          <span className="md:hidden">{format(date, "EEE").toUpperCase()}</span>
          <span className="hidden md:inline">{format(date, "EEEE")}</span>
        </h3>

        <div className="space-y-1 md:space-y-2 flex flex-col justify-start py-1">
          {tasks.length === 0 ? (
            <p className="text-gray-400 text-[8px] md:text-xs text-center py-1 md:py-4">
              No tasks
            </p>
          ) : (
            <>
              {tasks.map((task) => (
                <div
                  key={task.id}
                  className="flex items-center gap-1 md:gap-2 w-full px-1"
                >
                  <span
                    className={`text-[8px] md:text-xs text-white flex-1 overflow-hidden truncate min-w-0 ${
                      task.completed ? "line-through text-gray-500" : ""
                    }`}
                  >
                    {task.text}
                  </span>
                  <div className="flex-shrink-0 hidden md:block">
                    <Checkmark
                      completed={task.completed}
                      onToggle={(e) => {
                        e.stopPropagation();
                        toggleTask(task.id, task.completed);
                      }}
                      size="w-3 h-3 md:w-4 md:h-4"
                    />
                  </div>
                </div>
              ))}
            </>
          )}
        </div>
      </div>

      <TaskModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        selectedDate={date}
        tasks={tasks}
        onAddTask={addTask}
        onRemoveTask={removeTask}
        onToggleTask={toggleTask}
      />
    </>
  );
}
